import Auth from '../modules/Authentication'
import {apiUrl, streamUrl} from '../variables/index'
import {handleErrors, handleResponse} from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Posts {
  constructor() {
    this.auth = new Auth()
  }

  list = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}posts/`, {headers}).then(handleErrors)
  }
  preview = list => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${streamUrl}preview/`, {
      headers,
      method: 'POST',
      body: JSON.stringify(list),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  create = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}posts/`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
  like = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}posts/like`, {
      headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  delete = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}posts/`, {
      headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  comments = {
    create: data => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}posts/comments`, {
        headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    list: key => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}posts/${key}/comments/`, {headers})
        .then(handleErrors)
        .then(handleResponse)
    },
    delete: data => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}posts/comments/`, {
        headers,
        method: 'DELETE',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
}
